import { dealerInformationStyles } from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import Phone from "@insite/mobius/Icons/Phone";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

dealerInformationStyles.nameText = {
    weight: "bold",
    ellipsis: true,
    css: css`
        color: ${COLORS.primaryBlue} !important;
    `,
}

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = {
    icon: {
        iconProps: {
            src: ChevronLeft,
            css: css`
                svg {
                    height: 22px;
                    width: 22px;
                }
            `,
        },
        position: "left",
    },
    css: css`
        padding-left: 10px;
        &:focus {
            outline: none;
        }
        > span {
            font-size: ${TYPOGRAPHY.size.small};
        }
    `,
};

dealerInformationStyles.phoneLink = {
    icon: {
        iconProps: {
            src: Phone,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
            padding-left: 10px;
        `,
    },
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 6,
    css: css`
        padding-left: 40px;
    `,
};

dealerInformationStyles.googleMapsDirectionLink = {
    css: css`
        &:focus {
            outline: none;
        }
    `,
}

dealerInformationStyles.visitWebsiteLink = {
    css: css`
        &:focus {
            outline: none;
        }
    `,
}